<template>
  <section class="overview">
    <h3>{{ $t('message.national_data_statistics_latest') }}</h3>
    <div class="updated">{{ $t('message.last_updated') }}: {{ update.time }}</div>
    <div class="board">
      <div class="item confirmed">
        <div class="value">{{ overview.confirmed }}</div>
        <div class="name">{{ $t('message.current_confirmed') }}</div>
      </div>
      <div class="item recovered">
        <div class="value">{{ overview.recovered }}</div>
        <div class="name">{{ $t('message.current_recovered') }}</div>
      </div>
      <div class="item deceased">
        <div class="value">{{ overview.deceased }}</div>
        <div class="name">{{ $t('message.current_deceased') }}</div>
      </div>
    </div>
    <div class="information"><Icon type="info-circle-o" />{{ $t('message.national_data_statistics_source') }}</div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Icon from '@/components/Icon'

export default {
  name: 'Overview',
  computed: {
    ...mapState({
      overview: (state) => state.visions.overview || {},
      update: (state) => state.visions.update || {},
    }),
  },
  components: {
    Icon,
  },
}
</script>

<style lang="less" scoped>
.overview {
  padding: 12px 24px;
  border-bottom: 1px solid #f9f9f9;
  h3 {
    font-size: 14px;
    margin: 1em 0 0.5em;
    &, a {
      color: #333;
    }
  }
  .updated {
    font-size: 12px;
    color: hsl(0, 0%, 60%);
    margin: 0 0 1.5em;
    padding: 0;
  }
  .board {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
    padding: 16px 0;
    .item {
      .value {
        font-size: 24px;
        font-weight: bold;
      }
      .name {
        font-size: 12px;
        font-weight: bold;
        color: #666;
      }
      &.confirmed {
        .value {
          color: hsl(4,50%,50%);
        }
      }
      &.recovered {
        .value {
          color: hsl(120,50%,50%);
        }
      }
      &.deceased {
        .value {
          color: hsl(220,10%,30%);
        }
      }
    }
  }
  .information {
    font-size: 12px;
    font-style: italic;
    color: hsl(0, 0%, 60%);
    margin: 1.5em 0;
    padding: 0;
  }
}
</style>
